export default __webpack_public_path__ + "static/media/logo-txt.22c8659e.png";